export default __webpack_public_path__ + "static/media/img_note1.c648e860.png";